
  <div class="border-b border-gray-300 p-4 my-3" [formGroup]="voucherFilterForm">
    <div class="flex flex-row">
      <div class="sm:col-span-4">
        <label for="CreatorId" class="block text-sm/6 font-medium text-gray-900">CreatorId</label>
        <div class="mt-2">
          <input id="CreatorId" formControlName="CreatorId" type="integer" placeholder="CreatorId"
            class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
        </div>
      </div>

      <div class="sm:col-span-4 mx-2">
        <label for="name" class="block text-sm/6 font-medium text-gray-900">name</label>
        <div class="mt-2">
          <input id="name" formControlName="name" type="text" placeholder="name"
            class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
        </div>
      </div>

      <div class="sm:col-span-4 mx-2" >

      </div>
    </div>

    <div class="flex flex-row-reverse mt-4 px-4 sp pe-10">
      <button (click)="onSubmit()" class="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded mx-2">
        Apply
      </button>
      <button (click)="onReset()" class="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded mx-2">
        Reset
      </button>
    </div>
  </div>
